<template>
  <span id="receiving-detail-dialog">
    <span><a @click="handleOpenDialog" class="text-link">{{ $t('outbound.loads.receiving') }}</a></span>
    <el-dialog
    :close-on-click-modal="false"
    :visible.sync="dialogVisible"
    width="65%">
      <span slot="title">
        <el-row :gutter="20">
          <el-col :span="24" :xs="18">
            <span class="el-dialog__title">
              {{ $t('outbound.loads.shipperBreakdown') }}
            </span>
            <el-tooltip class="item" effect="dark" :enterable="false" :content="$t('common.refresh')" placement="top-start">
              <el-button @click="handleSearch" icon="el-icon-refresh" size="mini" class="button-action-default search-summary-refresh-button"></el-button>
            </el-tooltip>
            <span class="span-small-list">
              <span class="el-pagination__title">{{ $t('outbound.loads.totalUnits') }}</span>
              {{ totalUnits }}
            </span>
            <span class="span-small-list">
              <span class="el-pagination__title">{{ $t('outbound.loads.received') }}</span>
              {{ totalReceivedUnits }}
            </span>
            <span class="span-small-list">
              <span class="el-pagination__title">{{ $t('outbound.loads.cubes') }}</span>
              {{ cubes }}
            </span>
          </el-col>
        </el-row>
      </span>
      <el-table
          :data="shipperList"
          v-loading="loading"
          id="receiving-detail-data-list"
          size="mini"
          tooltip-effect="dark"
          width="80%"
          class="dark-blue-table"
          :empty-text="$t('common.noRecords')"
          @sort-change="handleSortChange"
          :default-sort="{prop: 'shipper', order: 'ascending'}"
          sortable
          stripe>
          <el-table-column
             prop="shipper"
            :label="$t('outbound.loads.shipper')"
            align="left"
            header-align="center"
            :min-width="30"
            sortable="custom"/>
          <el-table-column
             prop="billed"
            :label="$t('outbound.loads.billed')"
            align="center"
            :min-width="30"
            sortable="custom">
          </el-table-column>
          <el-table-column
             prop="received"
            :label="$t('outbound.loads.received')"
            align="center"
            :min-width="30"
            sortable="custom">
          </el-table-column>
          <el-table-column
            :min-width="7"
            :label="$t('common.options')"
            align="center"
            class-name="fixed-width">
            <template slot-scope="scope">
              <span> <receiving-product-detail-dialog :ship-date="currentRow.shipDate" :shipper-account-id="scope.row.shipperAccountId" /> </span>
            </template>
      </el-table-column>
        </el-table>
      <div id="receiving-detail-dialog-footer" slot="footer" class="pagination-footer" v-show="totalShippers > 0">
        <span class="el-pagination__total" slot>
          <span class="el-pagination__title" slot>{{ $t('outbound.loads.totalShippers') }}</span>
          {{ totalShippers }}
        </span>
        <el-pagination
            :page-sizes="sizes"
            :page-size="searchParams.rows"
            :current-page.sync="searchParams.page"
            @size-change="handleSearchChangeLimit"
            @current-change="handleSearchChangePage"
            :total="totalShippers"
            layout="sizes, prev, pager, next, jumper"
          >
      </el-pagination>
      </div>
    </el-dialog>
  </span>
</template>

<script>
import constants from '@/utils/constants';
import ReceivingProductDetailDialog from './ReceivingProductDetailDialog';

export default {
  name: 'ReceivingDetailDialog',
  components: { ReceivingProductDetailDialog },
  props: {
    currentRow: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      dialogVisible: false,
      sizes: constants.TABLES.DEFAULT_LIMIT_SIZES,
      shipperList: [],
      totalShippers: 0,
      totalUnits: 0,
      totalReceivedUnits: 0,
      cubes: 0,
      loading: false,
      searchParams: {
        origin: null,
        shipDate: null,
        rows: constants.TABLES.DEFAULT_LIMIT,
        page: constants.TABLES.DEFAULT_PAGE,
        pageResults: true,
        orderField: 'shipper',
        orderDirection: constants.TABLES.ORDER_DIRECTION.ascending
      }
    };
  },
  methods: {
    handleOpenDialog() {
      this.dialogVisible = true;
      this.searchParams.origin = this.currentRow.origin;
      this.searchParams.shipDate = this.currentRow.shipDate;
      this.handleSearch();
    },
    handleSearchChangeLimit(val) {
      this.searchParams.rows = val;
      this.searchParams.page = constants.TABLES.DEFAULT_PAGE;
      this.handleSearch();
    },
    handleSearchChangePage(val) {
      this.searchParams.page = val;
      this.handleSearch();
    },
    handleSortChange({ prop, order }) {
      this.searchParams.orderField = prop;
      this.searchParams.orderDirection = constants.TABLES.ORDER_DIRECTION[order];
      this.handleSearch();
    },
    handleSearch() {
      this.loading = true;
      this.$store.dispatch('loads/getShipperBreakdown', this.searchParams).then(
        (response) => {
          this.shipperList = response.data;
          this.totalShippers = response.totalRows;
          this.totalUnits = response.totalUnits;
          this.cubes = response.cubes;
          this.totalReceivedUnits = response.totalReceivedUnits;
        }
      ).finally(() => {
        this.loading = false;
      });
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss">
  span#receiving-detail-dialog {
    .text-link {
      text-decoration: underline;
      color: #59AFE1;
    }

    .span-small-list {
      display: inline;
      margin-left: 1rem;
    }

    th {
      .cell {
        line-height: 32px;
        height: 32px;
      }
    }
  }
  @media (max-width: 450px) {
    span#receiving-detail-dialog .span-small-list {
      display: block;
      margin-left: 0;
    }
    .el-dialog {
      width: 100% !important;
    }
    .el-dialog__body {
      padding: 20px 5px;
    }
  }
</style>
